import { Box, Fade, Paper, Typography } from '@mui/material';
import DocumentsSection from '@acorn-portal/shared/src/components/renewal/documents-section';
import { useAppDispatch, useAppSelector } from '@acorn-portal/shared/src/hooks/reduxHook';
import { useEffect, FC } from 'react';
import { useNavigate } from 'react-router';
import { ROUTE_PATHS } from '@acorn-portal/shared/src/utils/Routes';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { green } from '@mui/material/colors';
import AcornBanner from '@acorn-portal/shared/src/components/banner/AcornLanderBanner';
import { format } from 'date-fns';
import { DISPLAY_DATE_TIME } from '@acorn-portal/shared/src/utils/constants';
import { resetSubscriptionData } from '@acorn-portal/shared/src/store/subscription.slice';
import { WelcomePackSendStatus } from '@acorn-portal/shared/src/services/subscriptionAPI';

const PaymentSuccess: FC = () => {
	const restartTakeUp = useAppSelector((state) => state.takeUpDetails);
	const dispatch = useAppDispatch();
	const fullPolicy = useAppSelector((state) => state.fullPolicy);
	const navigate = useNavigate();

	useEffect(() => {
		if (restartTakeUp.policyNumber) {
			dispatch(resetSubscriptionData());
		} else {
			navigate(ROUTE_PATHS.home);
		}
	}, []);

	const getDisplayDateTime = () => {
		const parseDate = new Date(restartTakeUp.startTime ?? Date.now());
		return format(parseDate, DISPLAY_DATE_TIME);
	};

	return (
		<Paper
			elevation={1}
			sx={{
				borderRadius: '8px',
			}}
		>
			<AcornBanner
				text={
					<Box
						sx={(theme) => ({
							[theme.breakpoints.down('md')]: { fontSize: '1.4rem' },
							[theme.breakpoints.down('sm')]: {
								fontSize: '1rem',
							},
						})}
					>
						<b>Thank you</b>
						<br />
						for your payment...
					</Box>
				}
			/>
			<Fade in>
				<Box
					sx={{
						p: { xs: 2, md: 4 },
						margin: 2,
						textAlign: 'center',
						display: 'flex',
						flexDirection: 'column',
						justifyContent: 'center',
						alignItems: 'center',
					}}
				>
					<Box
						sx={{
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'start',
							p: 2,
							borderRadius: 2,
							backgroundColor: green[50],
							my: 2,
						}}
					>
						<CheckCircleIcon sx={{ color: green[500], marginRight: 1, fontSize: '32px' }} />
						<Typography
							sx={{
								fontWeight: 400,
								fontSize: '18px',
								color: green[500],
							}}
						>
							Your renewal has been successful with the effective date of {getDisplayDateTime()}
						</Typography>
					</Box>
					<Typography fontSize={16} paddingBottom={4} color='secondary'>
						Please find your policy documents below
					</Typography>
					<Typography sx={{ maxWidth: { md: '50%' } }}>
						Your policy reference number: <strong>{restartTakeUp.policyNumber}</strong>
						<br /> Details of how to access the documents have been emailed to you and are available below
					</Typography>
					{restartTakeUp.sendWelcomePackStatus === WelcomePackSendStatus.ENQUEUED && (
						<Typography sx={{ margin: 'auto', textAlign: 'center', p: 2 }}>
							We&apos;ve also sent your updated documents in the post, they will arrive in 3-5 working days.
						</Typography>
					)}
					<DocumentsSection policy={fullPolicy} subscription={true} />
				</Box>
			</Fade>
		</Paper>
	);
};

export default PaymentSuccess;
